import { render, staticRenderFns } from "./product_info.vue?vue&type=template&id=794408b7&scoped=true&"
import script from "./product_info.vue?vue&type=script&lang=js&"
export * from "./product_info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "794408b7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('794408b7')) {
      api.createRecord('794408b7', component.options)
    } else {
      api.reload('794408b7', component.options)
    }
    module.hot.accept("./product_info.vue?vue&type=template&id=794408b7&scoped=true&", function () {
      api.rerender('794408b7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/catalog/products/product/tabs/product_info.vue"
export default component.exports